export const USERS = "users/";

export const GET_USER_BY_ID = (id: string) => `users/${id}`
export const CREATE_USER = "users/";
export const CONFIRM_USER = "users/confirm-account";
export const CONFIRM_PASSWORD = "users/confirm-password";
export const FORGOT_PASSWORD = "users/forgot-password";